import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Button } from 'grommet'

export const Container = styled.div`
  background-color: ${themeGet('colors.white')};
`

export const Section = styled.section`
  margin-bottom: 1.75rem;
`

export const SectionHeader = styled.h3`
  margin: 0 0 0.75rem;
  color: ${themeGet('colors.hsSecondaryDarkGreen')};
  font-family: ${themeGet('fonts.kometHeavy28.fontFamily')};
  font-weight: ${themeGet('fonts.kometHeavy28.weight')};
  font-size: 1.125rem;
  line-height: 1.5rem;
`

export const TileGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 17.625rem);
  justify-content: start;
  gap: 1.25rem;

  ${themeGet('breakpoints.belowTablet')} {
    grid-template-columns: 17.625rem;
  }
`

export const TileButton = styled.button`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  box-sizing: border-box;
  width: 17.625rem;
  height: 6.125rem;
  margin: 0;
  padding: 0.75rem 1rem;
  border: 0.125rem solid ${themeGet('colors.highschool.gray2')};
  border-radius: 0.625rem;
  background-color: ${themeGet('colors.white')};
  text-align: left;
  overflow: hidden;
  cursor: pointer;

  :hover,
  :focus-visible {
    border-color: ${themeGet('colors.highschool.pink1')};
    outline: none;
  }
`

export const TileImage = styled.img`
  position: absolute;
  top: -0.25rem;
  right: -0.25rem;
  bottom: -0.25rem;
  left: -0.25rem;
  width: calc(100% + 0.5rem);
  height: calc(100% + 0.5rem);
  object-fit: fill;
  pointer-events: none;
`

export const TileTitle = styled.span`
  position: relative;
  z-index: 1;
  color: ${themeGet('colors.highschool.green2')};
  font-family: ${themeGet('fonts.moldeMedium16.fontFamily')};
  font-size: ${themeGet('fonts.moldeMedium16.fontSize')};
  line-height: 1.25rem;
`

export const PacingPill = styled.span`
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 6.25rem;
  height: 1.25rem;
  padding: 0;
  border: ${props => (props.$isCurrent ? '1px solid #E6BAC8' : 'none')};
  border-radius: 0.8125rem;
  background-color: ${props => (props.$isCurrent ? '#FAEEF3' : '#E3E3E3')};
  color: ${themeGet('colors.highschool.green2')};
  font-family: ${themeGet('font.molde.regular')};
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1;
  letter-spacing: 0;
  white-space: nowrap;
`

export const StaticDescriptionLinkContainer = styled(Button)`
  border: 0.125rem solid ${themeGet('colors.highschool.gray2')};
  border-radius: 0.625rem;
  padding: 0.75rem;
  padding-left: 1rem;
  width: 100%;
  height: 100%;
  max-width: 18.438rem;

  h4 {
    margin: 0;
    color: ${themeGet('colors.highschool.pink1')};
    font-size: ${themeGet('fonts.moldeMedium16.fontSize')};
    font-family: ${themeGet('fonts.moldeMedium16.fontFamily')};
  }
  p {
    margin: 0;
  }
  :hover {
    cursor: pointer;
    h4 {
      color: ${themeGet('colors.hsSecondaryGreen')};
    }
  }
`

export const StaticLinksPanelContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-items: center;
  align-items: center;
  grid-gap: 1.25rem;
  margin-top: 1.3rem;

  // set a higher breakpoint so we can maintain a smaller height for each link box:
  ${themeGet('breakpoints.medium')} {
    grid-template-columns: repeat(auto-fit, minmax(12.5rem, 1fr));
    justify-items: left;
  }
`

export const StyledHairline = styled.hr`
  margin-top: 2.5rem;
  // 1px top + 1px bottom = 2px total height:
  border: 0.063rem solid ${themeGet('colors.highschool.gray2')};
`
